module.exports = __webpack_public_path__ + "media/images/signatures/kamill_signature_white-76a251115ea7ac59cb53cee4dd598466.png";